import React from 'react';
import { VdsBasicInput as VoltVdsBasicInput } from '@volt/volt-extended-components-react';

type BasicInputProps = React.ComponentProps<typeof VoltVdsBasicInput>;

export function VdsBasicInputSafe(props: BasicInputProps) {
  const { id, ...rest } = props;

  const isValidId = id !== undefined && id !== null;

  const sanitizedProps = isValidId ? props : rest;

  return <VoltVdsBasicInput {...sanitizedProps} />;
}

export default VdsBasicInputSafe;
